/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0; you may not use this file except in compliance with the Elastic License
 * 2.0.
 */

// DO NOT MODIFY THIS FILE BY HAND. IT IS GENERATED BY
// `yarn workspace @elastic/esql-definitions generate` FROM
// `elasticsearch/esql/x-pack-esql/definition/functions/atan2.json`.

import type { DefinitionDocs } from '../../definition_types';

const docs: DefinitionDocs = {
  description: 'The angle between the positive x-axis and the ray from the\norigin to the point (x , y) in the Cartesian plane, expressed in radians.',
  examples: [
    'ROW y=12.9, x=.6\n| EVAL atan2=ATAN2(y, x)',
  ],
  params: {
    y_coordinate: 'y coordinate. If `null`, the function returns `null`.',
    x_coordinate: 'x coordinate. If `null`, the function returns `null`.',
  },
};

export default docs;
